import { datesToISO } from "@";

const toIntOrNull = (value) =>
  value === "" || value === null || value === undefined
    ? null
    : parseInt(value);

// search values payload
export const searchValuesPayload = (page, perSize, search) => ({
  page: page,
  pageSize: perSize,
  searchKey: search.searchKey,
  toDate: datesToISO(search.toDate),
  projectId: toIntOrNull(search.project),
  toAmount: toIntOrNull(search.toAmount),
  fromDate: datesToISO(search.fromDate),
  fromAmount: toIntOrNull(search.fromAmount),
  paymentType: toIntOrNull(search.paymentType),
  classificationId: toIntOrNull(search.classificationId),
  ...(Array.isArray(search.columns) && search.columns.length > 0
    ? { columns: search.columns }
    : {}),
});
